/* eslint-disable react/prop-types */
import "./MouseMap.css";

export const MouseMap = ({ children, posX, posY, color = "#FFFFFF", opacity = 0, offscreen }) => {
  return (
    <div
      className={`mouse-map${offscreen ? ` offscreen ${offscreen}` : ""}`}
      style={{
        left: `${posX}px`,
        top: `${posY}px`,
        opacity: opacity,
        transition: "opacity 0.5s ease-in-out",
      }}
    >
      <div className="cursor">
        <svg
          fill={color}
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="20px"
          height="20px"
          viewBox="-26.65 -26.65 319.80 319.80"
          xmlSpace="preserve"
          stroke="#000000"
          strokeWidth="0.00266495"
        >
          <g strokeLinecap="round" strokeLinejoin="round" stroke="#272727" strokeWidth="26.6495">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M150.036,266.494c-0.264,0-0.517-0.006-0.792-0.018c-6.102-0.337-11.332-4.474-13.046-10.347l-26.067-89.027 l-95.203-18.867c-6.014-1.194-10.614-6.059-11.476-12.123c-0.858-6.062,2.201-12.016,7.65-14.832L242.143,1.617 C247.5-1.175,254.057-0.29,258.518,3.8c4.474,4.101,5.885,10.55,3.562,16.146l-98.743,237.655 C161.097,263.018,155.836,266.494,150.036,266.494z"></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>
          <g>
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M150.036,266.494c-0.264,0-0.517-0.006-0.792-0.018c-6.102-0.337-11.332-4.474-13.046-10.347l-26.067-89.027 l-95.203-18.867c-6.014-1.194-10.614-6.059-11.476-12.123c-0.858-6.062,2.201-12.016,7.65-14.832L242.143,1.617 C247.5-1.175,254.057-0.29,258.518,3.8c4.474,4.101,5.885,10.55,3.562,16.146l-98.743,237.655 C161.097,263.018,155.836,266.494,150.036,266.494z"></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      </div>
      <div
        className="name"
        style={{
          backgroundColor: color,
        }}
      >
        {children}
      </div>
    </div>
  );
};
